import { Injectable, inject } from "@angular/core";
import {
  MatSnackBar,
  MatSnackBarConfig
} from "@angular/material/snack-bar";
import { ToastComponent, ToastData } from "./toast.component";

/**
 * Sitewide toast/notification service — the standard replacement for alert().
 * Wraps Angular Material's MatSnackBar (our design-system component — no extra
 * dependency) and renders a minimal white card with a thin colored left bar +
 * state icon via ToastComponent. Top-center; success/error/info variants.
 *
 * Usage:  private toast = inject(ToastService);
 *         this.toast.success("Saved");  this.toast.error(msg);  this.toast.info(msg);
 */
@Injectable({ providedIn: "root" })
export class ToastService {
  private snack = inject(MatSnackBar);

  private base: MatSnackBarConfig = {
    horizontalPosition: "center",
    verticalPosition: "top",
    panelClass: ["trd-toast-panel"]
  };

  private open(data: ToastData, duration: number): void {
    this.snack.openFromComponent(ToastComponent, {
      ...this.base,
      duration,
      data
    });
  }

  success(message: string, action = "OK"): void {
    this.open({ message, action, type: "success", icon: "check_circle" }, 4000);
  }

  error(message: string, action = "Dismiss"): void {
    this.open({ message, action, type: "error", icon: "error_outline" }, 6000);
  }

  info(message: string, action = "OK"): void {
    this.open({ message, action, type: "info", icon: "info" }, 4000);
  }
}
